// @ts-nocheck
import React, { useState } from 'react';
import CaptureLogo from '../../components/ui/CaptureLogo';
import { TermsModal, PrivacyModal } from '../../components/ui';
import AuthVisualPanel from './AuthVisualPanel';

/**
 * Two-column auth layout. Left: brand header + form panel. Right: marketing
 * visual stage (hidden on mobile). Children render in the centered form area.
 * Footer hosts Terms + Privacy modal triggers, plus a Help link.
 */
const AuthShell = ({
  eyebrow,
  headline,
  lede,
  children,
}) => {
  const [termsOpen, setTermsOpen] = useState(false);
  const [privacyOpen, setPrivacyOpen] = useState(false);

  const footerBtn = 'bg-transparent border-0 p-0 text-mov-ink-mute hover:text-mov-ink cursor-pointer mono uppercase';
  const footerBtnStyle = { letterSpacing: '0.04em', fontSize: '12px' };

  return (
    <div className="auth-root min-h-screen">
      <main className="grid lg:grid-cols-[minmax(0,1fr)_minmax(0,1.05fr)] min-h-screen">
        <section className="bg-mov-paper flex flex-col px-6 sm:px-10 lg:px-14 py-8 lg:border-r lg:border-mov-line">
          <div className="flex-1 flex items-center justify-center py-10">
            <div className="w-full max-w-[380px]">
              <div className="mb-10">
                <CaptureLogo style={{ width: 160 }} />
              </div>

              <div className="mono text-[11px] uppercase text-mov-green-ink inline-flex items-center gap-2 mb-[22px]" style={{ letterSpacing: '0.14em' }}>
                <span className="w-[6px] h-[6px] rounded-full bg-mov-green" style={{ boxShadow: '0 0 0 3px #ecf3df' }} />
                <span>{eyebrow}</span>
              </div>

              <h1 className="display text-[44px] leading-[1.05] m-0 mb-[10px] text-mov-ink">
                {headline}
              </h1>
              {lede && (
                <p className="text-mov-ink-soft text-[15px] leading-[1.5] m-0 mb-8">
                  {lede}
                </p>
              )}

              {children}
            </div>
          </div>

          <footer className="flex items-center justify-between text-mov-ink-mute text-[12px] mono pt-4" style={{ letterSpacing: '0.04em' }}>
            <span>© {new Date().getFullYear()} Movology</span>
            <span className="flex items-center gap-3">
              <button type="button" onClick={() => setTermsOpen(true)} className={footerBtn} style={footerBtnStyle}>
                Terms
              </button>
              <span className="text-mov-line-strong">·</span>
              <button type="button" onClick={() => setPrivacyOpen(true)} className={footerBtn} style={footerBtnStyle}>
                Privacy
              </button>
              <span className="text-mov-line-strong">·</span>
              <a href="https://movology.com/contact" target="_blank" rel="noreferrer" className="text-mov-ink-mute hover:text-mov-ink no-underline">Help</a>
            </span>
          </footer>
        </section>

        <AuthVisualPanel />
      </main>

      <TermsModal open={termsOpen} onClose={() => setTermsOpen(false)} />
      <PrivacyModal open={privacyOpen} onClose={() => setPrivacyOpen(false)} />
    </div>
  );
};

export default AuthShell;
